"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var MapContainer = _styledComponents.default.section.withConfig({
  displayName: "MapContainer",
  componentId: "sc-8s5p20-0"
})(["width:", ";height:", ";position:relative;"], function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var height = _ref2.height;
  return height;
});

var _default = MapContainer;
exports.default = _default;